import { render, staticRenderFns } from "./CleaningDetails.vue?vue&type=template&id=4951c6b0&scoped=true&"
import script from "./CleaningDetails.vue?vue&type=script&lang=js&"
export * from "./CleaningDetails.vue?vue&type=script&lang=js&"
import style0 from "./CleaningDetails.vue?vue&type=style&index=0&id=4951c6b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4951c6b0",
  null
  
)

export default component.exports